export class WebAppInfo {
  public readonly appVersion = "1.5.21 (9)";

}
